const prettify = (key) =>
  key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

const escapeCell = (val) => {
  if (val == null) return "";
  const s = String(val);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

// Export an array of plain objects to a downloadable CSV.
// Excludes internal fields; derives headers from remaining keys.
export function exportToCsv(filename, rows, excludeKeys = ["id", "created_at"]) {
  if (!rows || rows.length === 0) return;
  const keys = Object.keys(rows[0]).filter((k) => !excludeKeys.includes(k));
  const header = keys.map((k) => escapeCell(prettify(k))).join(",");
  const body = rows.map((row) => keys.map((k) => escapeCell(row[k])).join(",")).join("\n");
  const csv = `${header}\n${body}`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
